import { defineMessages } from 'react-intl';

export const messages: {
	caseLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	closedOn: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	closesOn: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	caseLabel: {
		id: 'search-graph-case.case-label',
		defaultMessage: 'Case',
		description: 'Case noun type label for Salesforce Case search results',
	},
	closedOn: {
		id: 'search-graph-case.closed-on',
		defaultMessage: 'Closed on {date}',
		description: 'Date when the Salesforce case was closed',
	},
	closesOn: {
		id: 'search-graph-case.closes-on',
		defaultMessage: 'Closes on {date}',
		description: 'Future date when the Salesforce case is expected to close',
	},
});
